export const EWorkspaceSubscriptionTypePersonal = {
  PERSONAL_FREE: 'PERSONAL_FREE',
  PERSONAL_ADVANCED: 'PERSONAL_ADVANCED',
  PERSONAL_PRO: 'PERSONAL_PRO',
};
